import { List, ListItem, Box, Typography, Collapse, IconButton, Button } from '@mui/material';
import { useState } from 'react';
import { LANGUAGES } from '../constants';
import dropdownIcon from '../assets/images/dropdown-icon.svg';
import closeIcon from '../assets/images/close-icon.svg';
import whatsappIcon from '../assets/images/whatsapp-icon.svg';
import { useTranslation } from 'react-i18next';
import './NavigationDrawer.css';

function NavigationDrawer({ 
  open, 
  onClose, 
  language, 
  country, 
  countryOptions,
  onLanguageChange, 
  onCountryChange 
}) {
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const { t } = useTranslation();

  const handleCountryClick = (value) => {
    onCountryChange({ target: { value }});
    setIsCountryOpen(false);
  };

  const handleLanguageClick = (code) => {
    onLanguageChange({ target: { value: code }});
    setIsLanguageOpen(false);
  };

  return (
    <>
      <div 
        className={`drawer-overlay ${open ? 'open' : ''}`} 
        onClick={onClose}
      />
      <div 
        className={`custom-drawer ${open ? 'open' : ''}`}
        data-direction={LANGUAGES[language].dir}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end',
          padding: 1
        }}>
          <IconButton 
            onClick={onClose}
            sx={{
              padding: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            <img 
              src={closeIcon} 
              alt="Close"
              style={{ 
                width: 50, 
                height: 50 
              }} 
            />
          </IconButton>
        </Box>
        <List>
          <ListItem sx={{ justifyContent: 'flex-start' }}>
            <Box sx={{ width: '100%' }}>
              <Box 
                onClick={() => setIsCountryOpen(!isCountryOpen)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: 1,
                  cursor: 'pointer',
                }}
              >
                <Typography 
                style={{fontWeight: 500}}>
                  {countryOptions.find(option => option.value === country)?.label || t('labels.selectCountry')}
                </Typography>
                <img 
                  src={dropdownIcon} 
                  alt="" 
                  style={{ 
                    width: 20, 
                    height: 20,
                    transform: isCountryOpen ? 'rotate(180deg)' : 'none',
                    transition: 'transform 0.3s ease'
                  }} 
                />
              </Box>
              <Collapse in={isCountryOpen}>
                <Box sx={{ mt: 1 }}>
                  {countryOptions.map(({ value, label }) => (
                    <Box
                      key={value}
                      onClick={() => handleCountryClick(value)}
                      sx={{
                        padding: 1,
                        cursor: 'pointer',
                        bgcolor: country === value ? 'action.selected' : 'transparent',
                        '&:hover': {
                          bgcolor: 'action.hover'
                        },
                        textAlign: 'start'
                      }}
                    >
                      <Typography
                      style={{fontWeight: 500}}>
                        {label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Collapse>
            </Box>
          </ListItem>
          <ListItem sx={{ justifyContent: 'flex-start' }}>
            <Box sx={{ width: '100%' }}>
              <Typography 
                sx={{ 
                  color: 'text.secondary',
                  fontWeight: 500,
                  mb: 2,
                  px: 1,
                  textAlign: 'start'
                }}
              >
                {t('labels.chooseLanguage')}
              </Typography>
              <Box sx={{ 
                display: 'flex', 
                gap: 2,
                px: 1
              }}>
                {Object.values(LANGUAGES).map(({ code, label }) => (
                  <Box
                    key={code}
                    onClick={() => handleLanguageClick(code)}
                    sx={{
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderRadius: '20px',
                      fontWeight: 500,
                      bgcolor: language === code ? 'primary.main' : 'transparent',
                      color: language === code ? 'white' : 'text.primary',
                      border: language === code ? 'none' : '2px solid #e0e0e0',
                      '&:hover': {
                        bgcolor: language === code ? 'primary.dark' : 'rgba(0, 0, 0, 0.04)'
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Typography
                      style={{fontWeight: 500}}>
                      {label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </ListItem>
          {/* <ListItem sx={{ justifyContent: 'flex-start', mt: 2 }}>
            <Button
              variant="outlined"
              href="http://wa.me/966502210258"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                width: '100%',
                borderRadius: '20px',
                padding: '12px 24px',
                backgroundColor: 'white',
                border: '2px solid #e0e0e0',
                color: 'text.primary',
                textTransform: 'none',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  border: '2px solid #e0e0e0'
                },
                display: 'flex',
                gap: 2,
                justifyContent: 'flex-start'
              }}
            >
              <img 
                src={whatsappIcon} 
                alt=""
                style={{ 
                  width: 24, 
                  height: 24 
                }} 
              />
              <Typography style={{ fontWeight: 500 }}>
                {t('labels.contactUs')}
              </Typography>
            </Button>
          </ListItem> */}
        </List>
      </div>
    </>
  );
}

export default NavigationDrawer;